import { Entity } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ErrorBoundaryWrapper } from '~/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { SendAllAssetsTo } from '~/components/send-all-assets-to/SendAllAssetsTo';

import { useCompetitorsData } from '../../hooks/useCompetitorsData';
import { CompetitorsTable } from './competitors-table/CompetitorsTable';
import * as S from './CompetitorsTab.styles';

interface CompetitorsTabProps {
  entity: Entity;
}

export const CompetitorsTab = ({ entity }: CompetitorsTabProps) => {
  const { t } = useTranslation(['widget']);

  const { tableData, columnsMeta, isError, isFetching } = useCompetitorsData({
    entityTag: entity.tag,
  });

  const displayedEntityTags = tableData
    .filter(row => row.hasData)
    .map(row => row.entity?.tag) as string[];

  return (
    <ErrorBoundaryWrapper>
      {!!displayedEntityTags.length && (
        <S.MenuBar>
          <S.AssetsCounter>
            {t(
              'widget:assetOverview.knowledgeGraph.competitors.assetsCounter',
              {
                count: displayedEntityTags.length,
              }
            )}
          </S.AssetsCounter>
          <SendAllAssetsTo
            entityTags={displayedEntityTags}
            source="asset_overview"
          />
        </S.MenuBar>
      )}
      <S.ScrollContainer>
        <CompetitorsTable
          tableData={tableData}
          columnsMeta={columnsMeta}
          isError={isError}
          isFetching={isFetching}
        />
      </S.ScrollContainer>
    </ErrorBoundaryWrapper>
  );
};
